import { IVacancies } from "./IVacancies";
import { MobXModel } from "src/repository/MobXModel";

export const vacanciesModel = new MobXModel<IVacancies>();
